import { useRouter } from 'next/router';
import { createContext, useContext } from 'react';

// Lets a host supply the entity id when it isn't in the router query, so the
// entity-header components (which resolve their id via `useEntityId`) can mount
// outside the /users/[id] and /businesses/[id] routes — e.g. on the
// investigation page. Deliberately separate from `useEntityContext` so the
// existing `kind`/`listPath` consumers are untouched.
const EntityIdContext = createContext<string | undefined>(undefined);

export const EntityIdProvider = EntityIdContext.Provider;

const useEntityId = () => {
  const overrideId = useContext(EntityIdContext);
  const router = useRouter();
  return (overrideId ?? router.query.id ?? router.query.fpId) as string;
};

export default useEntityId;
